export default function parallax () {
    const el = $('[data-parallax-img]');

    function getV (m) {
        return m.attr('data-parallax-img');
    }

    function shiftImage () {
        const scrolled = window.pageYOffset;
        const speed = getV(el);

        el.css({transform: 'translateY(' + (scrolled * speed) + 'px)'});
        window.requestAnimationFrame(shiftImage);
    }

    if (el.length) {
        window.requestAnimationFrame(shiftImage);

        $(window).on('resize', shiftImage);
        $(window).on('scroll', shiftImage);
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/parallax-header.js